import React from 'react';
import { View, Text, Grid, Styles } from 'primase';
import { useTranslation, Trans } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

// Helpers
import { useFeatureFlags } from 'helpers/hooks';

// Constants
import {
  REACT_APP_MYRIAD_PRIVACY_POLICY_URL,
  REACT_APP_MYRIAD_TOS_URL,
  REACT_APP_MYRIAD_NONDISCRIMINATION_URL,
  REACT_APP_MYRIAD_AVAILABILITY_NOTICE_URL,
  REACT_APP_MYRIAD_HIPAA_NOTICE_URL,
} from 'constants/links';
import { REACT_APP_CONTACT_US_URL } from 'constants/support';

// Components
import { Footer } from 'components/destiny/footer';
import { A } from '../link';

// Styles
import { styles } from './styles';

const footerLinks = [
  {
    url: REACT_APP_MYRIAD_TOS_URL,
    labelKey: 'labels.termsOfUse',
  },
  {
    url: REACT_APP_MYRIAD_PRIVACY_POLICY_URL,
    labelKey: 'labels.footer.privacyNotice',
  },
  {
    url: REACT_APP_MYRIAD_NONDISCRIMINATION_URL,
    labelKey: 'labels.footer.nondiscrimination',
  },
  {
    url: REACT_APP_MYRIAD_AVAILABILITY_NOTICE_URL,
    labelKey: 'labels.footer.availability',
  },
  {
    url: REACT_APP_MYRIAD_HIPAA_NOTICE_URL,
    labelKey: 'labels.footer.hipaaNotice',
  },
  {
    url: REACT_APP_CONTACT_US_URL,
    labelKey: 'labels.footer.contact',
  },
];

export const MppFooter = () => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery({ query: '(min-width: 980px)' });

  const TOS = (
    <A styles={styles.centerText} to={REACT_APP_MYRIAD_TOS_URL} target="_blank">
      <Text css={styles.footerLinkText}>{t('labels.termsOfUse')}</Text>
    </A>
  );
  const privacy = (
    <A
      styles={styles.centerText}
      to={REACT_APP_MYRIAD_PRIVACY_POLICY_URL}
      target="_blank"
    >
      <Text css={styles.footerLinkText}>{t('labels.privacy')}</Text>
    </A>
  );
  const contactUs = (
    <A styles={styles.centerText} to={REACT_APP_CONTACT_US_URL} target="_blank">
      <Text css={styles.footerLinkText}>{t('labels.contactUs')}</Text>
    </A>
  );

  const legalText = (
    <Text css={styles.footerLegalText}>
      <Trans
        i18nKey="labels.footerCopyright"
        components={[<sup>&reg;</sup>]}
        values={{ year: new Date().getFullYear() }}
      />
    </Text>
  );

  const desktopFooter = (
    <Grid container css={styles.desktopFooterContainer}>
      <Grid item md={9} lg={9}>
        {legalText}
      </Grid>
      <Grid item md={3} lg={3}>
        <Grid container css={styles.desktopLinksContainer}>
          <Grid item css={styles.desktopLinkWrapper} md={4} lg={4}>
            {TOS}
          </Grid>
          <Grid item css={styles.desktopLinkWrapper} md={4} lg={4}>
            {privacy}
          </Grid>
          <Grid item css={styles.desktopLinkWrapper} md={4} lg={4}>
            {contactUs}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );

  const mobileFooter = (
    <>
      <View row css={{ margin: '0 auto' }}>
        <View inline css={styles.mobileLinkWrapper}>
          {TOS}
        </View>
        <View inline css={styles.mobileLinkWrapper}>
          {privacy}
        </View>
        <View inline css={styles.mobileLinkWrapper}>
          {contactUs}
        </View>
      </View>
      <View css={styles.mobileFooterLegalTextWrapper}>{legalText}</View>
    </>
  );

  return (
    <View
      data-testid="app-footer__wrapper"
      classes={{
        ...(window.env.UPP_CONSULTS_ENABLED === 'true'
          ? {
              [`@media (min-width: ${Styles.layout.Breakpoints.sm}px)`]: {
                backgroundColor: Styles.color.neutral.neutral2,
              },
            }
          : {}),
      }}
    >
      {isDesktop ? desktopFooter : mobileFooter}
    </View>
  );
};

export const AppFooter = () => {
  const { uppConsultsEnabled } = useFeatureFlags();

  return uppConsultsEnabled ? <Footer links={footerLinks} /> : <MppFooter />;
};
export default React.memo(AppFooter);
